import React, { useState } from 'react';
import { Form, Input, Button, Card, Alert, Row, Col, message } from 'antd';
import { UserOutlined, LockOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../api';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './Login.css';

const Login = ({ onLogin }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    setError('');
    
    try {
      const response = await authAPI.login({
        ...values,
        turnstile_token: ''
      });
      const { access_token } = response.data;
      localStorage.setItem('token', access_token);
      
      // 获取用户信息以确定跳转路径
      const userResponse = await authAPI.getProfile();
      const userInfo = userResponse.data;
      
      // 等待App组件更新认证状态
      const loginSuccess = await onLogin(access_token);
      
      if (loginSuccess) {
        // 检查是否有pending action
        const pendingActionStr = localStorage.getItem('pending_action');
        if (pendingActionStr) {
          try {
            const pendingAction = JSON.parse(pendingActionStr);
            localStorage.removeItem('pending_action'); // 清除pending action
            
            // 如果是dropshipper且有pending action，执行相应操作
            if (userInfo.role === 'dropshipper' && pendingAction.action === 'order_samples') {
              // 将产品信息保存到selected_product_for_order
              const productData = {
                product_id: pendingAction.product_id,
                product_name: pendingAction.product_name,
                variant_path: pendingAction.variant_path,
                variant_data: pendingAction.variant_data,
                quantity: 1
              };
              localStorage.setItem('selected_product_for_order', JSON.stringify(productData));
              navigate(pendingAction.redirect_url);
              return;
            }
          } catch (error) {
            
            localStorage.removeItem('pending_action');
          }
        }
        
        // 正常的角色跳转
        if (userInfo.role === 'admin') {
          navigate('/admin');
        } else if (userInfo.role === 'dropshipper') {
          navigate('/dropshipper');
        } else {
          navigate('/dashboard'); // 其他角色跳转到通用dashboard
        }
      } else {
        setError('Failed to update authentication state');
      }
    } catch (err) {
      
      
      if (err.response) {
        // 服务器返回了错误响应
        const status = err.response.status;
        const detail = err.response.data?.detail;
        
        if (status === 401 && detail === 'Incorrect username or password') {
          setError('Incorrect username or password');
        } else if (status === 401) {
          setError('Authentication failed');
        } else {
          setError(`Server error (${status}): ${detail || 'Unknown error'}`);
        }
      } else if (err.request) {
        // 请求已发出但没有收到响应
        setError('Unable to connect to server. Please check your network connection.');
      } else {
        // 其他错误
        setError(`Error: ${err.message}`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page shared-background">
      <div className="login-header-wrapper">
        <Header />
      </div>

      <div className="login-content">
        <Row justify="center" style={{ width: '100%' }}>
        <Col xs={20} sm={16} md={12} lg={8} xl={6}>
          <Card 
            title={
              <div style={{ textAlign: 'center', fontSize: '24px', fontWeight: 'bold' }}>
                Login
              </div>
            }
            style={{ 
              boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
              borderRadius: '10px',
              background: 'rgba(255, 255, 255, 0.5)'
            }}
          >
            <Form
              name="login"
              onFinish={onFinish}
              size="large"
              layout="vertical"
            >
              {error && (
                <Alert
                  message={error}
                  type="error"
                  showIcon
                  style={{ marginBottom: 16 }}
                />
              )}

              <Form.Item
                label="Username"
                name="username"
                required={false}
                rules={[{ required: true, message: 'Please enter username!' }]}
              >
                <Input 
                  prefix={<UserOutlined />} 
                  placeholder="Enter username" 
                />
              </Form.Item><Form.Item
                label="Password"
                name="password"
                required={false}
                rules={[{ required: true, message: 'Please enter password!' }]}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="Enter password"
                />
              </Form.Item>

              <Form.Item>
                <Button 
                  type="primary" 
                  htmlType="submit" 
                  loading={loading}
                  style={{ width: '100%', height: '40px' }}
                >
                  Login
                </Button>
              </Form.Item>

              <div style={{ textAlign: 'center' }}>
                Need an account? Please contact support to request access.
              </div>
            </Form>
          </Card>
        </Col>
      </Row>
      </div>

      <div className="login-footer-wrapper">
        <Footer />
      </div>
    </div>
  );
};

export default Login;
